import { BusinessGroupsApi } from './permission-api-client';
import { initializePermissionApi } from './utils';

export const businessGroupsApi = initializePermissionApi(BusinessGroupsApi);
